import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2";
import "../ModalConfirmacao2/ModalConfirmacao2.css";

export interface SimpleDialogProps {
	titulo?: string;
	tituloBotao?: string;
	texto?: string;
	open: boolean;
	textoBotao?: string;
	voltar?: any;
	onClose: () => void;
	onClick: () => void;
}

function ModalConfirmacao2(props: SimpleDialogProps) {
	const { onClose, open, onClick } = props;

	const handleClose = () => {
		onClose();
	};

	const handleClick = () => {
		onClick();
		onClose();
	};

	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<div className="div-modal-confirmacao">
					<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{props.texto}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							titulo={props.textoBotao}
							cor="#DC2D2D"
							onClick={handleClick}
						/>
						{!props.voltar && (
							<CustomButtonV2
								classCss="custom-button-cadastrar-gray"
								classText="button-texto-cadastrar"
								titulo="Voltar"
								cor="#0946B8"
								onClick={handleClose}
							/>
						)}
					</DialogActions>
				</div>
			</Dialog>
		</div>
	);
}

export default ModalConfirmacao2;
